/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
const Paypal = ({ Amount, attributes }) => {

    const { setPaymentRes, setTransactionId, setPaymentLod } = useContext(MyContext);

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    useEffect(() => {
        const loadPayPalScript = () => {
            const script = document.createElement('script');
            script.src = `https://www.paypal.com/sdk/js?client-id=${attributes.split(",")[0]}`;
            script.async = true;
            script.onload = () => setIsScriptLoaded(true);
            document.body.appendChild(script);
        };
        if (!isScriptLoaded) {
            loadPayPalScript();
        }
    }, [isScriptLoaded]);

    useEffect(() => {
        if (isScriptLoaded && window.paypal) {
            renderPayPalButton();
        }
    }, [isScriptLoaded]);


    const renderPayPalButton = () => {
        setPaymentLod(false);
        window.paypal.Buttons({
            createOrder: (data, actions) => {
                return actions.order.create({
                    purchase_units: [{
                        amount: {
                            value: Amount,
                        },
                    }],
                });
            },
            onApprove: (data, actions) => {
                return actions.order.capture().then((details) => {
                    setPaymentRes("PaymentDone");
                    setTransactionId(details.id);
                });
            },
            onCancel: () => {
                setPaymentRes("PaymentFaild");
            },
            onError: (err) => {
                console.error(err);
            },
        }).render('#paypal-button-container');
    };


    return (
        <div className='w-full'>
            <div id="paypal-button-container"></div>
        </div>
    );
};

export default Paypal;
/* jshint ignore:end */

